import { TREE_CONDITIONS, type TreeCondition } from '@api/types'
import { useI18n } from '@i18n/I18nProvider'
import { CONDITION_STYLES } from '@ui/ConditionBadge'

const CHIP = 'inline-flex min-h-12 items-center gap-2 rounded-full border-2 px-4 font-semibold'

// Filtro por estado: "Todos" o uno de los cuatro (con su color y SIEMPRE su nombre).
export const ConditionFilter = ({
	value,
	onChange,
}: {
	value: TreeCondition | undefined
	onChange: (next: TreeCondition | undefined) => void
}) => {
	const { t } = useI18n()
	const options: [TreeCondition | undefined, string][] = [
		[undefined, t('trees.all')],
		...TREE_CONDITIONS.map((c): [TreeCondition, string] => [c, t(`condition.${c}`)]),
	]
	return (
		<fieldset className="mb-4">
			<legend className="sr-only">{t('trees.filter')}</legend>
			<div className="flex flex-wrap gap-2">
				{options.map(([condition, label]) => {
					const selected = condition === value
					return (
						<button
							key={condition ?? 'all'}
							type="button"
							aria-pressed={selected}
							onClick={() => onChange(condition)}
							className={`${CHIP} ${selected ? 'border-forest-800 bg-forest-800 text-white' : 'border-earth-300 bg-white text-forest-900'}`}
						>
							{condition && (
								<span
									className={`size-3 rounded-full ${CONDITION_STYLES[condition]} ${selected ? 'ring-2 ring-white' : ''}`}
									aria-hidden="true"
								/>
							)}
							{label}
						</button>
					)
				})}
			</div>
		</fieldset>
	)
}
